import SubscriptionItem from './SubscriptionItem'
import ProfileForm from './Profile'
import LoginHistory from './LoginHistory'
import Orders from './Orders'
import ManageUserSubscription from './ManageUserSubscription'
import { TabLink, Tab } from '../../uiLib/Tabs'
import { Button } from '../../uiLib'
import { Link } from '../../../routes'


const UserDetails = props => (
  <div className="m-b-md">
    { props.isAdminView && props.selectedUser ? (
      <div className="m-b-md">
        <div className="font-16">
          {props.t('common:account_page-description-admin')}:&nbsp;
          {props.selectedUser.first_name} {props.selectedUser.last_name}&nbsp;
          <strong>{props.selectedUser.username}</strong>
        </div>
        <div className="m-t-md">
          <Link route="/admin">
            <Button
              outlined
              className="is-default"
              btType="default" >
              {props.t('common:back-to-users-list')}
            </Button>
          </Link>
        </div>
      </div>
    ) : (
      <div>
        {/* <h1 className="is-size-3 m-b-lg">{props.t('common:account_page-title')}</h1> */}
        {/* <p className="m-b-md">{props.t('common:account_page-description')}</p> */}
      </div>
  ) }
    <div className="tabs">
      <ul>
        <TabLink
          isActive={props.activeTab === 'profile'}
          onClick={() => props.setTab('profile')}
          title={props.t('profile')}
        />
        <TabLink
          isActive={props.activeTab === 'purchases'}
          onClick={() => props.setTab('purchases',  () => props.loadOrders(props.userId))}
          title={props.t('purchases')}
        />
        <TabLink
          isActive={props.activeTab === 'login_history'}
          onClick={() => props.setTab('login_history', () => props.loadLoginHistory(props.userId))}
          title={props.t('login-history')}
        />
      </ul>
    </div>
    <div className="tabs-content column is-12">
      <Tab isActive={props.activeTab === 'profile'}>
        <div className="column is-6">
          <ProfileForm {...props} />
        </div>
      </Tab>
      <Tab isActive={props.activeTab === 'purchases'}>
        <h2 className="title is-5">{props.t('subscriptions')}</h2>
        <div className="subscriptions-wrapper column is-6">
          { props.isAdminView ?
            (
              <ManageUserSubscription
                handleSubscriptionDateSubmit={props.handleSubscriptionDateSubmit}
                subscriptions={props.subscriptions}
                loading={props.loading}
                t={props.t} />
            ) : (
              <div>
                <SubscriptionItem
                  id="esi-subscription"
                  title={props.t('account_page-esi-subscription')}
                  dateTo={props.subscriptions.sub_exp_date}
                  linkTo="/electronic-service"
                  />
                <SubscriptionItem
                  id="pats-subscription"
                  title={props.t('account_page-pats-subscription')}
                  dateTo={props.subscriptions.pats_exp_date}
                  linkTo="/pats-codes"
                />
                <SubscriptionItem
                  id="pcm-subscription"
                  title={props.t('account_page-pcm-subscription')}
                  dateTo={props.subscriptions.reprog_exp_date}
                  linkTo="/pcm-reflashing"
                />
                <SubscriptionItem
				  id="mdars-subscription"
                  title={props.t('account_page-mdars-subscription')}
                  dateTo={props.subscriptions.mdars_exp_date}
                  linkTo="/ids-software"
                />
                <SubscriptionItem
                  id="ids-subscription"
                  title={props.t('account_page-ids-subscription-title')}
                  dateTo={props.subscriptions.ids_exp_date}
                  linkTo="/ids-software"
                />
                <SubscriptionItem
                  id="training-subscription"
                  title={props.t('account_page-training-subscription-title')}
                  dateTo={props.subscriptions.training_exp_date}
                  linkTo="/training-information"
                />
              </div>
          )}

        </div>
        <h2 className="title is-5">{props.t('purchase-history')}</h2>
        <div className="order-history column is-8 m-b-md p-b-md">
          <Orders
            userId={props.userId}
            list={props.ordersList}
            pageCount={props.ordersPageCount}
            handlePageClick={props.handleOrderPageClick}
            initialPage={props.ordersCurrentPage}
            loading={props.isOrdersListLoading}
            hideRefundModal={props.hideRefundModal}
            showRefundModal={props.showRefundModal}
            confirmRefundRequestSubmit={props.confirmRefundRequestSubmit}
            selectedRefundModalId={props.selectedRefundModalId}
            isRefundRequestInProgress={props.isRefundRequestInProgress}
          />
        </div>
      </Tab>
      <Tab isActive={props.activeTab === 'login_history'}>
        <LoginHistory
          userId={props.userId}
          list={props.loginHistoryList}
          pageCount={props.loginHistoryPageCount}
          handlePageClick={props.handleLoginHistoryPageClick}
          initialPage={props.currentPage}
        />
      </Tab>
    </div>
  </div>
)

export default UserDetails



// WEBPACK FOOTER //
// ./components/Common/UserDetails/index.js